var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "id": "print-target"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center pa-3 pt-6 pa-md-7 pt-md-14"
  }, [_c('h3', {
    staticClass: "report-title"
  }, [_vm._v("전자제조지원단 기술자문 보고서")])]), _c('v-card-text', [_c('v-sheet', {
    staticClass: "mb-8 mb-md-15"
  }, [_c('div', {
    staticClass: "counsel-report"
  }, [_c('table', {
    staticClass: "table--primary"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("작성업체")]), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.request.requester.companyName))]), _c('th', [_vm._v("담당자명")]), _c('td', [_vm._v(_vm._s(_vm.request.requester.workerName))])]), _c('tr', [_c('th', [_vm._v("연락처")]), _c('td', [_vm._v(_vm._s(_vm.request.requester.phone.phoneNumberFormat()))])]), _vm.isLong ? _c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("분야")]), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.areaName))]), _c('th', [_vm._v("자문요청일")]), _c('td', [_vm._v(_vm._s(_vm.request.startsAt.toDate()))])]) : _c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("분야")]), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.areaName))]), _c('th', [_vm._v("자문요청일")]), _c('td', [_vm._v(_vm._s(_vm.request.createdAt.toDate()))])]), _vm.isLong ? _c('tr', [_c('th', [_vm._v("자문종료일")]), _c('td', [_vm._v(_vm._s(_vm.request.endsAt.toDate()))])]) : _c('tr', [_c('th', [_vm._v("자문종료일")]), _c('td', [_vm._v(_vm._s(_vm.request.endedAt.toDate()))])]), _c('counsels-report-row', {
    attrs: {
      "colspan": "3",
      "label": "자문주제",
      "content": _vm.request.title
    }
  }), _c('counsels-report-row', {
    attrs: {
      "colspan": "3",
      "label": "기술자문내용",
      "content": _vm.request.content
    }
  }), _c('counsels-report-row', {
    attrs: {
      "colspan": "3",
      "label": "첨부파일"
    }
  }, [_c('div', {
    staticClass: "text-btn-wrap"
  }, _vm._l(_vm.request.files, function (file) {
    return _c('v-btn', {
      key: file._id,
      staticClass: "text-decoration-underline",
      attrs: {
        "href": file.url,
        "download": "",
        "text": "",
        "color": "primary"
      }
    }, [_vm._v(" " + _vm._s(file.fileName) + " ")]);
  }), 1)])], 1)])]), _c('v-sheet', {
    staticClass: "mb-9 mb-md-16"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('h4', {
    staticClass: "report-title2"
  }, [_vm._v("답변내용")])]), _c('div', {
    staticClass: "row--primary"
  }, _vm._l(_vm.request.responses, function (response) {
    return _c('v-row', {
      key: response._id,
      attrs: {
        "no-gutters": "",
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "report-nickname"
    }, [_c('v-avatar', {
      attrs: {
        "size": "22"
      }
    }, [_vm._v("A")]), _vm._v(_vm._s(response.responder.nickname))], 1)]), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "7"
      }
    }, [_vm._v(" " + _vm._s(response.content) + " "), _c('div', {
      staticClass: "mt-1 mt-md-2"
    }, [_c('div', {
      staticClass: "text-btn-wrap"
    }, _vm._l(response.files, function (file) {
      return _c('v-btn', {
        key: file._id,
        staticClass: "text-decoration-underline",
        attrs: {
          "href": file.url,
          "download": "",
          "text": "",
          "color": "primary"
        }
      }, [_vm._v(" " + _vm._s(file.fileName) + " ")]);
    }), 1)])]), _c('v-col', {
      staticClass: "text-right text-md-center",
      attrs: {
        "cols": "12",
        "md": "2"
      }
    }, [_vm._v(_vm._s(response.createdAt.toDateTime()))])], 1);
  }), 1)]), _c('v-sheet', [_c('div', {
    staticClass: "report-bottom"
  }, [_c('div', {
    staticClass: "report-bottom__txt"
  }, [_vm._v("위의 자문 결과에 대한 사실을 확인합니다.")]), _c('div', {
    staticClass: "report-bottom__date"
  }, [_vm._v(_vm._s(_vm.now))]), _c('div', {
    staticClass: "report-bottom__company"
  }, [_c('p', [_vm._v(_vm._s(_vm.request.requester.companyName) + " " + _vm._s(_vm.request.requester.ceoName))]), _c('p', [_vm._v("KEA전자제조지원단")])]), _c('div', {
    staticClass: "report-bottom__tit"
  }, [_vm._v("한국 전자정보 통신 산업 진흥회 귀하")])])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }